document.addEventListener("DOMContentLoaded", function () {
  // Select the elements
  const openBtn = document.querySelector(".menu-toggler");
  const menuWrapper = document.querySelector(".menu-wrapper");

  // Add click event listener to the openBtn
  openBtn.addEventListener("click", function () {
    // Toggle the '.active' class on the menuWrapper
    menuWrapper.classList.toggle("active");

    // Toggle the '.-close' class on the openBtn
    openBtn.classList.toggle("-close");
  });

  // Function to handle window resize
  function handleResize() {
    if (window.innerWidth > 992) {
      // Remove the '.active' class from the menuWrapper
      menuWrapper.classList.remove("active");

      // Remove the '.-close' class from the openBtn
      openBtn.classList.remove("-close");
    }
  }

  // Add resize event listener to the window
  window.addEventListener("resize", handleResize);

  // Call handleResize once to check the initial window size
  handleResize();
});
